// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fullscreen-exit"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 19V13.5H5.00001M5 19L9.66655 14.3335M14.3335 9.66655L19 5M13.5 5.00001V10.5H19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FullscreenExitIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fullscreen-exit',
    ref,
    icon: element,
  },
));

FullscreenExitIcon.displayName = 'FullscreenExitIcon';

export default FullscreenExitIcon;
